import React from 'react'
import ReactTooltip, { TooltipProps } from 'react-tooltip'
import styled from 'particles/themes/styled'
import { theme } from 'theme'

const BasePartiTooltip = styled(ReactTooltip)`
    padding: ${theme.spacing.xxs};
    box-shadow:
        0px 2px 4px rgba(43, 50, 178, 0.2),
        0px 4px 5px rgba(43, 50, 178, 0.14),
        0px 1px 10px rgba(43, 50, 178, 0.12);
    pointer-events: auto !important;
`

export const PartiTooltip: React.FC<TooltipProps> = ({
    backgroundColor = theme.newColors.neutral50,
    place = 'top',
    ...props
}) => {
    return (
        <BasePartiTooltip
            {...props}
            html
            type="light"
            place={place}
            borderColor={theme.colors.astronaut}
            effect="solid"
            delayShow={0}
            multiline={true}
            backgroundColor={backgroundColor}
        />
    )
}

const Tooltips: React.FC = () => {
    return (
        <>
            <PartiTooltip id="partiTooltip" globalEventOff="click" border={true} />
        </>
    )
}

/**
 * @deprecated Please use particles/Tooltip
 */
// FIXME: remove ThemeProvider under src/components/Submissions/Review/Submissions/ProgressBlock/PopupUserInfo.tsx after migrating this component
export default Tooltips
